import { render, staticRenderFns } from "./lotterySuccess.vue?vue&type=template&id=52c5dfcb&scoped=true&"
import script from "./lotterySuccess.vue?vue&type=script&lang=js&"
export * from "./lotterySuccess.vue?vue&type=script&lang=js&"
import style0 from "./lotterySuccess.vue?vue&type=style&index=0&id=52c5dfcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5dfcb",
  null
  
)

export default component.exports